import { Input, Form } from "@renderbus/ui";
import styled from "styled-components";

export const InputComponent = styled(Input)`
  // 去除对应的增减
  &.ant-input-affix-wrapper {
    border: none;
    background-color: #212327;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  input[type="number"] {
    -moz-appearance: textfield;
  }
  &.ant-input-outlined.ant-input-status-error:not(
      .ant-input-disabled
    ):focus-within {
    background-color: #212327;
  }
  &.ant-input-affix-wrapper:hover,
  &.ant-input-outlined.ant-input-status-error:not(.ant-input-disabled):focus,
  &.ant-input-outlined.ant-input-status-error:not(.ant-input-disabled):hover {
    background-color: #212327;
  }
`;

export const RechargeForm = styled(Form)`
  margin-top: 18px;
  .ant-form-item {
    margin-bottom: 0;
  }
  .ant-form-item-control-input-content {
    display: flex;
    align-items: center;
    gap: 16px;
  }
  .fox-amount-input {
    width: 224px;
    height: 40px;
    margin: 6px 0 4px;
    .icon-input-wrapper {
      border-radius: 6px;
      overflow: hidden;
      border: 1px solid transparent;
      &:hover {
        box-shadow: 0px 0px 0px 2px var(--color-main-alpha-022);
        border: 1px solid var(--main-color) !important;
        transition: border 0.2s ease-in-out;
      }
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
    input[type="number"] {
      -moz-appearance: textfield;
    }
    .icon-input-wrapper {
      border: 1px solid #495359;
    }
    input {
      height: 19px;
    }
  }
  .ant-form-item-has-error {
    .fox-amount-input .icon-input-wrapper {
      color: #ff4d4f;
      border: 1px solid #ff4d4f !important;
    }
  }
`;

export const ChangeCouponCode = styled.div`
  width: 224px;
  height: 40px;
  line-height: 40px;
  border-radius: 8px;
  border: 1px solid #495359;
  background: #292b2f;
  position: relative;
  overflow: hidden;
  padding-left: 17px;
  .change-btn {
    position: absolute;
    right: 0;
    top: 0;
    width: 40px;
    height: 100%;
    border-left: 1px solid #495359;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
`;

export const CouponCodeTipWrapper = styled.div<{
  bg: string;
  titleColor: string;
}>`
  background: ${(p) => p.bg};
  line-height: 30px;
  min-width: 462px;
  width: max-content;
  font-size: 12px;
  border-radius: 4px;
  margin: 12px 6px 0 0;
  padding: 0 8px;
  display: inline-flex;
  align-items: center;
  font-weight: 600;
  svg {
    margin-right: 4px;
  }
  .pre-title {
    color: ${(p) => p.titleColor};
  }
  .gift-tip::after,
  .gift-tip::before {
    content: "";
    width: 1px;
    height: 12px;
    background: rgba(255, 255, 255, 0.24);
    margin: 0 6px;
    display: inline-block;
    vertical-align: middle;
  }
`;
